import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';

export class UpdateOrderNoteDto {
  @IsString()
  @IsOptional()
  @Expose()
  note?: string;
}
